import React from 'react';

interface State {
  show: () => void;
}

interface Props {
  children: (api: State) => React.ReactNode;
}

export class IntercomHandler extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      show: this.handleShow,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  handleShow = () => {
    const intercomAPI = global.Intercom;

    if (intercomAPI) {
      intercomAPI('show');
    }
  };

  render() {
    return this.props.children(this.state);
  }
}
